import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  forwardRef,
  SimpleChanges,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'rx-checkbox',
  templateUrl: './rx-checkbox.component.html',
  styleUrls: ['./rx-checkbox.component.scss'],
  imports: [CommonModule, FormsModule, MatRippleModule, MatCheckboxModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxCheckboxComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RxCheckboxComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RxCheckboxComponent implements OnInit, ControlValueAccessor, OnChanges, Validator {
  @Input()
  public id = 'item' + Math.random().toString(36).substring(2);

  private _title: string;
  @Input()
  public get title() {
    return this._title;
  }
  public set title(value: string) {
    this._title = value;
    this.titleSafeHtml = this.sanitizeTitle(value);
  }

  @Input()
  public checked: boolean;

  @Input()
  public disabled: boolean;

  @Output()
  public checkedChange = new EventEmitter<boolean>();

  public onChange = (value: boolean) => {};
  public onTouched = () => {};

  public control: FormControl;

  public titleSafeHtml: SafeHtml;

  constructor(private sanitizer: DomSanitizer) {}

  public ngOnInit() {}

  private sanitizeTitle(value: any) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  public ngOnChanges(changes: SimpleChanges | any): void {
    if (changes['title']) {
      this.titleSafeHtml = this.title;
    }
    this.onChange(this.checked);
  }

  public checkChanged(event) {
    this.checkedChange.emit(this.checked);
    this.onChange(this.checked);
  }

  // Register for change
  public registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  // Register for touch/click
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Update the model and changes
  public writeValue(value: boolean): void {
    if (this.checked !== value) {
      this.checked = value;
      this.onChange(this.checked);
    }
  }

  public isValid(): boolean {
    return !this.control?.pending && !this.control?.errors && !this.control?.invalid;
  }

  // validate
  public validate(control: FormControl): any {
    this.control = control;
    return control.valid ? null : control.errors;
  }
}
